module.exports = __webpack_public_path__ + "static/assets/b08301efa789f34c92da0d7a2edad526.png";